import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ComponentEventEmitter {

  private fullPageSpaceRequested = new Subject<boolean>();

  /**
   * @deprecated Use LayoutStateService instead
   */
  fullPageSpaceRequested$ = this.fullPageSpaceRequested.asObservable();

  private hideHeaderRequested = new Subject<boolean>();
  hideHeaderRequested$ = this.hideHeaderRequested.asObservable();

  /**
   * @deprecated Use LayoutStateService instead
   */
  broadcastFullPageSpaceRequested(state: boolean) {
    this.fullPageSpaceRequested.next(state);
  }

  broadcastHideHeaderRequested(state: boolean) {
    this.hideHeaderRequested.next(state);
  }
}
